import React from 'react';

function QuestionCount(props) {

  return (

    <div className="text-center">
      Question <span>{props.counter}</span> of <span>{props.total} </span>

    </div>
  );

}

QuestionCount.propTypes = {
  counter: React.PropTypes.number.isRequired,
  total: React.PropTypes.number.isRequired
};

export default QuestionCount;



// WEBPACK FOOTER //
// ./react/app/components/QuestionCount.js